import { PATH_PAGE } from "../../routes/paths";
import MenuClient from "../../assets/svg/menu/MenuClient";
import MenuResource from "../../assets/svg/menu/MenuResource";
import MenuRole from "../../assets/svg/menu/MenuRole";
import MenuSetting from "../../assets/svg/menu/MenuSetting";

import MenuTimeSheet from "../../assets/svg/menu/MenuTimeSheet";

import DashboardIcon from "../../assets/svg/menu/DashboardIcon";

export const DashboardNavConfigPermissionDenied = (translate) => [
  {
    title: translate("Dashboard"),
    path: PATH_PAGE.dashboardPage.root,
    icon: <DashboardIcon />
  },
  {
    title: translate("clientManagement"),
    path: PATH_PAGE.dashboard,
    icon: <MenuClient />
  },
  {
    title: translate("ResourceManagement"),
    path: PATH_PAGE.dashboard,
    icon: <MenuResource />
  },
  {
    title: translate("Timesheets"),
    path: PATH_PAGE.resourcesManagement.root,
    icon: <MenuTimeSheet />
  },
  {
    title: translate("roles"),
    path: PATH_PAGE.dashboard,
    icon: <MenuRole />
  },
  {
    title: translate("settings"),
    path: PATH_PAGE.dashboard,
    icon: <MenuSetting />
  }
];
